import { normalizeDriverLanguage } from './driverI18n';

export const driverTermsTitle = "Big Taxi サービス利用規約（ドライバー用）";

export const driverTermsText = `Big Taxi サービス利用規約（ドライバー用）

第1条（適用）

本利用規約（以下「本規約」といいます。）は、Big Taxi（以下「当社」といいます。）が提供するドライバー向けアプリケーション、ウェブサイト、管理システムその他関連サービス（以下総称して「本サービス」といいます。）の利用条件を定めるものです。

本サービスを利用するドライバー、運転者、提携事業者又はその所属運転者（以下総称して「ドライバー」といいます。）は、本規約の内容を確認し、同意したうえで本サービスを利用するものとします。

ドライバーが本サービスへの登録、ログイン、注文の閲覧、受注申請、運行報告その他本サービスを利用した時点で、本規約に同意したものとみなします。

⸻

第2条（定義）

本規約において使用する用語の意味は、以下のとおりとします。

1. 「本アプリ」とは、当社がドライバー向けに提供する「Big Taxi Driver」その他名称を問わず当社が提供するアプリケーションソフトウェアをいいます。
2. 「ユーザー」とは、当社又は当社提携先を通じて送迎、貸切、ハイヤー、空港送迎その他移動サービスを申し込む利用者をいいます。
3. 「ドライバー」とは、本サービスに登録し、当社所定の審査を経て、運行業務を行う者又はその候補者をいいます。
4. 「提携事業者」とは、当社と業務提携、委託、紹介、配車又はその他契約関係にある法人又は個人事業主をいいます。
5. 「運行業務」とは、本サービスを通じて提供される送迎、貸切、観光チャーター、空港送迎、駅送迎、港送迎その他旅客運送に関連する業務をいいます。
6. 「注文」とは、ユーザー又は当社が本サービス上で登録、表示、配車又は依頼する運行業務の情報をいいます。
7. 「車両」とは、ドライバー又は提携事業者が運行業務に使用する自動車をいいます。
8. 「登録情報」とは、氏名、電話番号、住所、免許証、在留カード、旅券、車検証、保険証券、銀行口座、車両写真その他当社が指定する情報をいいます。

⸻

第3条（本サービスの内容）

本サービスは、ドライバーに対し、主に以下の機能を提供します。

1. 注文情報の閲覧
2. 注文への受注申請又は受注確認
3. 運行日時、出発地、目的地、車両種別、乗客人数、荷物数、注意事項等の確認
4. 運行ステータスの報告
5. 当社又は管理者との連絡
6. ドライバー情報及び車両情報の登録、更新、審査
7. 報酬、精算予定額、ポイントその他業務関連情報の確認
8. その他当社が必要と認める機能

本サービスは、ドライバーに対して注文の獲得、一定の収入、特定の運行件数又は継続的な業務提供を保証するものではありません。

⸻

第4条（登録及び審査）

ドライバーは、本サービスの利用にあたり、当社が指定する方法により登録申請を行うものとします。

当社は、登録申請者に対し、以下の情報又は書類の提出を求めることができます。

1. 氏名、生年月日、住所、電話番号、メールアドレス
2. 運転免許証
3. 在留カード又は旅券
4. 車検証、自動車検査証記録事項
5. 自賠責保険証明書
6. 任意保険証券
7. 車両写真、車内写真、車両番号
8. 銀行口座情報
9. 所属会社、営業許可、運送事業に関する情報
10. その他当社が必要と判断する資料

当社は、提出された情報をもとに審査を行い、登録を承認又は拒否することができます。

当社は、審査結果の理由を開示する義務を負いません。

登録後であっても、当社が不適切と判断した場合、登録の停止、制限又は取消しを行うことができます。

⸻

第5条（資格及び法令遵守）

ドライバーは、本サービスの利用及び運行業務の実施にあたり、日本国の法令、条例、行政指導、許認可条件、交通規則及び当社の指示を遵守しなければなりません。

ドライバーは、運行業務に必要な運転免許、資格、許可、保険、車両状態及び営業上の適法性を自己の責任において維持するものとします。

ドライバーは、当社の事前承認なく、白ナンバー車両、自家用車、無許可車両、保険未加入車両又は運行に適さない車両を使用して有償運送を行ってはなりません。

ドライバー又は提携事業者が法令違反、行政処分、事故、苦情、免許停止、免許取消し、保険失効その他運行に重大な影響を及ぼす事情が発生した場合、速やかに当社へ報告しなければなりません。

⸻

第6条（登録情報の正確性）

ドライバーは、登録情報について、真実、正確かつ最新の内容を提供しなければなりません。

登録情報に変更が生じた場合、ドライバーは速やかに本アプリ又は当社指定の方法により変更手続きを行うものとします。

登録情報の虚偽、不備、更新漏れ又は提出遅延により損害、配車ミス、精算遅延、行政上の問題その他トラブルが発生した場合、当社は責任を負いません。

⸻

第7条（注文の受注及び配車）

ドライバーは、本アプリに表示される注文情報を確認し、受注申請又は受注確認を行うことができます。

当社は、注文の内容、車両種別、対応可能地域、ドライバー評価、ポイント、過去の実績、ユーザー要望、運行安全性その他当社が定める基準に基づき、注文の割当を決定することができます。

本アプリ上で注文が表示された場合であっても、当該注文の受注又は配車が確定することを保証するものではありません。

ドライバーは、受注後、正当な理由なく注文をキャンセルしてはなりません。

やむを得ず運行が困難となった場合、ドライバーは直ちに当社へ連絡し、当社の指示に従うものとします。

⸻

第8条（運行業務の実施）

ドライバーは、運行業務を安全、丁寧、誠実かつ適切に遂行しなければなりません。

ドライバーは、以下の事項を遵守するものとします。

1. 予約時刻、集合場所、目的地、経由地、フライト情報、列車情報、港情報、乗客人数、荷物数、特記事項を事前に確認すること
2. 遅刻、車両変更、事故、渋滞、体調不良その他運行に影響する事情がある場合、速やかに当社へ報告すること
3. 清潔な服装、清潔な車内環境及び丁寧な接客を維持すること
4. 運転中の安全確認、交通法規の遵守及び無理な運転の禁止
5. ユーザーの個人情報、行程、宿泊先、連絡先等を第三者へ漏えいしないこと
6. ユーザーに対し、当社の承認なく追加料金を直接請求しないこと
7. 当社又はユーザーに対し、虚偽の報告をしないこと

⸻

第9条（禁止事項）

ドライバーは、本サービスの利用にあたり、以下の行為を行ってはなりません。

1. 法令又は公序良俗に違反する行為
2. 無許可又は不適切な車両による運行
3. 飲酒運転、薬物使用状態での運転、危険運転、あおり運転
4. 免許停止中、免許取消し後又は運転資格を欠く状態での運行
5. 登録情報、証明書類、運行報告、走行時間、料金等の虚偽申告
6. 注文情報、ユーザー情報、当社情報を第三者へ無断提供する行為
7. 当社を通さずにユーザーと直接取引を行う行為
8. 当社又は他のドライバーの信用を毀損する行為
9. ユーザーへの迷惑行為、威圧的言動、差別的言動、ハラスメント行為
10. 本アプリの不正利用、改ざん、逆解析、不正アクセス
11. 複数アカウントの不正利用又は第三者へのアカウント貸与
12. 当社の許可なく本サービス上の情報を複製、保存、転載又は外部公開する行為
13. その他当社が不適切と判断する行為

⸻

第10条（報酬及び精算）

ドライバー又は提携事業者に支払われる報酬、手数料、精算方法、支払時期その他金銭条件は、当社が別途定める条件又は個別契約に従うものとします。

本アプリ上に表示される報酬額、予定精算額、ポイント、注文金額その他の金額は、確認時点における参考表示であり、最終的な支払額を保証するものではありません。

キャンセル、遅刻、未実施、ユーザーからの苦情、事故、返金、追加費用、システム上の誤表示その他事情が発生した場合、当社は精算額を修正することができます。

ドライバーは、当社の事前承認なく、ユーザーから現金、チップ、追加料金、手数料その他名目を問わず金銭を請求又は受領してはなりません。ただし、当社が認めた場合又はユーザーが任意で支払うチップについてはこの限りではありません。

⸻

第11条（ポイント及び評価）

当社は、ドライバーの運行実績、受注率、キャンセル率、遅刻、ユーザー評価、クレーム、事故、協力度その他の要素に基づき、ポイント又は評価を付与、変更又は取消しすることができます。

ポイント又は評価は、注文の割当、優先表示、審査、アカウント管理その他本サービスの運営に利用される場合があります。

当社は、ポイント又は評価の計算方法、付与基準、減点基準を必要に応じて変更することができます。

ポイントは金銭、電子マネーその他経済的価値に交換できるものではありません。ただし、当社が別途明示した場合を除きます。

⸻

第12条（事故・トラブル発生時の対応）

ドライバーは、事故、接触、怪我、車両故障、交通違反、ユーザーとのトラブル、荷物破損、忘れ物、遅延その他問題が発生した場合、直ちに安全確保を行い、必要に応じて警察、消防、保険会社その他関係機関へ連絡するものとします。

ドライバーは、上記の事象が発生した場合、速やかに当社へ報告し、当社の指示に従うものとします。

ドライバーが自己の故意又は過失により当社、ユーザー又は第三者に損害を与えた場合、ドライバーはその損害を賠償する責任を負うことがあります。

⸻

第13条（個人情報及び秘密保持）

当社は、ドライバーから取得する個人情報を、当社のプライバシーポリシーに従い適切に取り扱います。

ドライバーは、本サービスを通じて知り得たユーザー情報、注文情報、料金情報、当社の営業情報、提携先情報その他非公開情報を、当社の事前承諾なく第三者へ開示、漏えい、利用又は保存してはなりません。

ドライバーは、運行業務終了後も、本条に定める秘密保持義務を負うものとします。

⸻

第14条（アカウント管理）

ドライバーは、自己の責任においてアカウント、ID、パスワード、認証情報及び端末を適切に管理するものとします。

ドライバーは、アカウントを第三者に貸与、譲渡、共有又は使用させてはなりません。

アカウントの管理不備、第三者利用、不正利用等により発生した損害について、当社は責任を負いません。ただし、当社の故意又は重大な過失による場合を除きます。

⸻

第15条（本サービスの停止・変更）

当社は、以下の場合、ドライバーへ事前通知することなく、本サービスの全部又は一部を停止、変更又は終了することができます。

1. システム保守、点検又は更新を行う場合
2. 通信障害、サーバー障害、外部サービス障害が発生した場合
3. 天災地変、事故、感染症、行政指導、法令変更その他不可抗力が発生した場合
4. 本サービスの運営上又は技術上必要と判断した場合
5. その他当社が必要と判断した場合

当社は、本サービスの停止、変更又は終了によりドライバーに生じた損害について、当社の故意又は重大な過失がある場合を除き、責任を負いません。

⸻

第16条（利用制限・登録取消）

当社は、ドライバーが以下のいずれかに該当すると判断した場合、事前通知なく、本サービスの利用停止、注文表示の制限、受注停止、登録取消しその他必要な措置を行うことができます。

1. 本規約に違反した場合
2. 登録情報に虚偽又は重大な不備がある場合
3. 法令違反、交通違反、事故、苦情その他運行上の問題が発生した場合
4. 当社、ユーザー又は第三者に損害を与えた場合
5. 反社会的勢力に該当又は関与していると判断される場合
6. 長期間本サービスの利用がない場合
7. 当社からの連絡に対して合理的期間内に応答しない場合
8. その他当社がドライバーとして不適切と判断した場合

⸻

第17条（反社会的勢力の排除）

ドライバーは、自己又は所属会社が、暴力団、暴力団員、暴力団関係者、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他反社会的勢力に該当しないことを表明し、保証します。

ドライバーは、反社会的勢力に対する利益供与、名義貸し、業務委託、資金提供その他一切の関与を行ってはなりません。

当社は、ドライバーが本条に違反したと判断した場合、直ちに登録取消しその他必要な措置を行うことができます。

⸻

第18条（権利帰属）

本アプリ、本サービス、ロゴ、デザイン、文章、画像、プログラム、データベースその他一切の知的財産権は、当社又は正当な権利者に帰属します。

ドライバーは、当社の事前承諾なく、本サービスに関する情報を複製、転載、改変、販売、配布、公衆送信又は二次利用してはなりません。

⸻

第19条（損害賠償）

ドライバーが本規約に違反し、又は自己の故意若しくは過失により当社、ユーザー、提携先又は第三者に損害を与えた場合、ドライバーは当該損害を賠償する責任を負うものとします。

当社は、本サービスの利用に関連してドライバーに発生した損害について、当社の故意又は重大な過失がある場合を除き、責任を負いません。

⸻

第20条（規約の変更）

当社は、法令変更、サービス内容の変更、運営上の必要性その他相当の理由がある場合、本規約を変更することができます。

当社は、本規約を変更する場合、本アプリ内への掲載、ウェブサイトへの掲載、電子メール、通知その他適切な方法によりドライバーへ周知します。

変更後の規約は、当社が別途定める効力発生日から適用されます。ドライバーが変更後も本サービスを利用した場合、変更後の規約に同意したものとみなします。

⸻

第21条（準拠法及び管轄）

本規約は、日本法に準拠し、日本法に従って解釈されます。

本サービス又は本規約に関して当社とドライバーとの間で紛争が生じた場合、当社所在地を管轄する日本の裁判所を第一審の専属的合意管轄裁判所とします。

⸻

第22条（協議）

本規約に定めのない事項又は本規約の解釈に疑義が生じた場合、当社及びドライバーは、誠実に協議のうえ解決するものとします。

⸻

附則

本規約は、2026年〇月〇日より施行します。`;

const englishDriverTermsTitle = 'Big Taxi Terms of Service for Drivers';
const englishDriverTermsText = `Big Taxi Terms of Service for Drivers

1. Scope
These terms govern use of the Big Taxi driver application, websites, management systems, and related services. Registration, sign-in, viewing or accepting orders, and submitting trip reports constitute agreement to these terms.

2. Definitions
"App" means Big Taxi Driver and related software. "Customer" means a person requesting transportation through Big Taxi or a partner. "Driver" includes applicants, approved drivers, partner businesses, and their drivers. "Order" means a transportation request displayed or assigned through the service.

3. Registration and review
Applicants must provide accurate, current information and documents. Big Taxi may request additional information, reject an application, suspend access, or withdraw approval when requirements are not met. Approval does not guarantee any number of orders or income.

4. Account information
Drivers must promptly update changes to their license, residence status, contact information, vehicle, insurance, bank account, or company affiliation. False, expired, or incomplete information may result in suspension.

5. Driver and vehicle requirements
Drivers must hold all licenses and qualifications required by law. Vehicles must be lawfully registered, insured, inspected, maintained, clean, and appropriate for each service. A driver must not operate when a license, inspection, insurance, or other required document is expired.

6. Orders
Order availability, priority, assignment, change, and cancellation are determined by Big Taxi based on service needs, driver status, score, location, vehicle, and other operating conditions. A driver must review the order before accepting and must not transfer it without authorization.

7. Service performance
Drivers must arrive on time, drive safely, treat customers respectfully, protect luggage and personal information, follow the order details, and accurately report arrival, boarding, completion, waiting time, additional charges, incidents, and other required information.

8. Driver responsibilities
Drivers must comply with laws, traffic rules, airport and facility rules, Big Taxi instructions, and reasonable customer requests. Drivers must not drive while impaired, fatigued, unqualified, or otherwise unsafe, and must not submit false reports.

9. Prohibited conduct
Prohibited conduct includes unlawful or dangerous driving; unauthorized vehicles; false documents or reports; harassment or discrimination; direct transactions that bypass Big Taxi; account sharing; unauthorized disclosure, copying, or publication of service data; tampering, reverse engineering, or unauthorized access; and any conduct Big Taxi reasonably considers harmful or improper.

10. Compensation and settlement
Compensation, fees, settlement methods, and payment dates follow the applicable agreement or conditions separately presented by Big Taxi. Amounts displayed in the App are provisional. Big Taxi may correct settlements for cancellations, delays, incomplete service, complaints, accidents, refunds, additional fees, or display errors. Drivers must not request unauthorized payments from customers.

11. Scores and evaluations
Big Taxi may add, change, or remove scores based on completion rate, acceptance, cancellation, lateness, reviews, complaints, accidents, and cooperation. Scores may affect order priority, review, and account management and normally have no cash value.

12. Accidents and incidents
Drivers must first secure safety and contact police, emergency services, insurers, or other authorities when appropriate. Drivers must promptly notify Big Taxi and cooperate with investigation and instructions. A driver may be responsible for damage caused intentionally or negligently.

13. Personal information and confidentiality
Big Taxi handles driver information under its Privacy Policy. Drivers must keep customer, order, price, partner, and business information confidential and use it only to perform the service. Confidentiality continues after a trip or account ends.

14. Account security
Drivers are responsible for safeguarding their account, password, authentication information, and device. Accounts may not be lent, transferred, shared, or used by another person. Suspected unauthorized access must be reported immediately.

15. Service interruption and changes
Big Taxi may suspend, change, or end all or part of the service for maintenance, failures, external-service disruption, disaster, legal or administrative requirements, or operational necessity.

16. Suspension and cancellation
Big Taxi may restrict order access, suspend use, or cancel registration for a breach of these terms; false or materially incomplete information; legal, traffic, accident, complaint, or safety issues; harm to a customer or third party; involvement with antisocial forces; prolonged inactivity; failure to respond; or other reasonable grounds.

17. Exclusion of antisocial forces
Drivers and their organizations represent that they are not connected with organized crime or other antisocial forces and will not provide benefits, names, work, or funds to such persons.

18. Intellectual property
The App, service, logos, designs, text, images, software, and databases belong to Big Taxi or their lawful owners. They may not be copied, modified, sold, distributed, published, or reused without permission.

19. Liability
A driver who breaches these terms or intentionally or negligently causes damage may be responsible for that damage. Big Taxi is not liable for losses related to the service except where caused by its intent or gross negligence, subject to applicable law.

20. Changes to these terms
Big Taxi may revise these terms for legal, service, or operational reasons and will provide notice in the App, on its website, by email, or by another appropriate method. Continued use after the effective date constitutes acceptance.

21. Governing law and jurisdiction
These terms are governed by Japanese law. The Japanese court with jurisdiction over Big Taxi's principal place of business has exclusive agreed jurisdiction at first instance.

22. Consultation
Any matter not covered by these terms or any question of interpretation will be resolved through good-faith consultation.

Supplementary provision
The effective date will be shown in the App when these terms take effect.`;

const simplifiedDriverTermsTitle = 'Big Taxi 司机服务使用条款';
const simplifiedDriverTermsText = `Big Taxi 司机服务使用条款

1. 适用范围
本条款适用于 Big Taxi 司机 App、网站、管理系统及相关服务。注册、登录、查看或承接订单、提交行程报告即表示同意本条款。

2. 定义
“客户”指通过 Big Taxi 或合作方预约用车的人；“司机”包括申请人、审核通过的司机、合作企业及其所属司机；“订单”指平台显示或分配的用车任务。

3. 注册与审核
申请人必须提供真实、准确、有效的资料和证件。资料不完整、过期或不符合要求时，Big Taxi 可以要求补充、拒绝申请、暂停使用或取消资格。审核通过不代表保证订单数量或收入。

4. 资料更新
驾照、在留资格、联系方式、车辆、保险、银行账户或所属公司发生变化时，司机应及时更新。

5. 司机与车辆条件
司机必须持有法律要求的全部资格。车辆必须合法登记、投保、年检、维护并保持清洁。任何必要证件过期时不得营运。

6. 订单
订单的显示、优先顺序、分配、变更和取消由 Big Taxi 根据运营需要、司机状态、积分、位置和车型等决定。司机接单前应核对内容，未经许可不得转交他人。

7. 服务规范
司机应准时到达、安全驾驶、礼貌服务、保护行李和个人信息，并准确汇报到达、上车、完成、等待、追加费用和异常情况。

8. 司机义务
司机必须遵守法律、交通规则、机场及设施规定和 Big Taxi 指示。疲劳、饮酒、服药影响驾驶、资格无效或其他不安全状态下不得驾驶，不得虚假汇报。

9. 禁止事项
禁止违法或危险驾驶、使用未授权车辆、伪造资料或报告、骚扰或歧视、绕过平台私下交易、共享账号、泄露或擅自复制平台数据、篡改或逆向分析 App、非法访问系统，以及其他损害客户或平台的行为。

10. 报酬与结算
报酬、手续费、结算方式和付款时间以另行约定为准。App 显示金额为暂定值；发生取消、迟到、未完成、投诉、事故、退款、追加费用或显示错误时，Big Taxi 可以更正结算。未经许可不得向客户收费。

11. 积分与评价
Big Taxi 可根据完成率、接单、取消、迟到、评价、投诉、事故和配合情况调整积分。积分可用于派单、审核和账号管理，除另有说明外不具有现金价值。

12. 事故与异常
发生事故、受伤、故障、纠纷、物品损坏、遗失或延误时，应先确保安全，必要时联系警察、消防和保险公司，并立即向 Big Taxi 报告和配合处理。

13. 个人信息与保密
Big Taxi 按隐私政策处理司机资料。司机必须对客户、订单、价格、合作方及经营信息保密，仅可为完成服务而使用，保密义务在订单和账号结束后仍然有效。

14. 账号安全
司机应妥善保管账号、密码、验证信息和设备，不得出借、转让或共享账号。发现异常登录应立即报告。

15. 服务停止或变更
因维护、故障、外部服务中断、灾害、法律行政要求或运营需要，Big Taxi 可暂停、变更或终止全部或部分服务。

16. 使用限制与注销
违反条款、资料虚假或严重缺失、违法、事故、投诉、安全问题、损害他人、长期不使用、拒绝合理联系或其他不适合继续提供服务的情况，Big Taxi 可限制订单、暂停账号或取消资格。

17. 排除反社会势力
司机及所属单位确认与暴力团等反社会势力无关，也不会提供利益、名义、业务或资金。

18. 知识产权
App、标志、设计、文字、图片、程序和数据库归 Big Taxi 或合法权利人所有，未经许可不得复制、修改、销售、分发或公开。

19. 责任
司机违反条款或因故意、过失造成损失时，可能承担赔偿责任。除故意或重大过失及法律另有规定外，Big Taxi 不承担相关损失。

20. 条款变更
因法律、服务或运营需要，Big Taxi 可修改条款，并通过 App、网站、邮件或其他适当方式通知。生效后继续使用即视为同意。

21. 法律与管辖
本条款适用日本法律，与本服务有关的争议由 Big Taxi 所在地有管辖权的日本法院作为一审专属管辖法院。

22. 协商
未规定事项或解释疑义由双方诚信协商解决。

附则
条款生效日期将在 App 中公布。`;

const traditionalDriverTermsTitle = 'Big Taxi 司機服務使用條款';
const traditionalDriverTermsText = `Big Taxi 司機服務使用條款

1. 適用範圍
本條款適用於 Big Taxi 司機 App、網站、管理系統及相關服務。註冊、登入、查看或承接訂單、提交行程報告即表示同意本條款。

2. 定義
「客戶」指透過 Big Taxi 或合作方預約用車的人；「司機」包括申請人、審核通過的司機、合作企業及其所屬司機；「訂單」指平台顯示或分配的用車任務。

3. 註冊與審核
申請人必須提供真實、準確、有效的資料和證件。資料不完整、過期或不符合要求時，Big Taxi 可以要求補充、拒絕申請、暫停使用或取消資格。審核通過不代表保證訂單數量或收入。

4. 資料更新
駕照、在留資格、聯絡方式、車輛、保險、銀行帳戶或所屬公司變更時，司機應及時更新。

5. 司機與車輛條件
司機必須持有法律要求的全部資格。車輛必須合法登記、投保、檢驗、維護並保持清潔。任何必要證件過期時不得營運。

6. 訂單
訂單的顯示、優先順序、分配、變更和取消由 Big Taxi 根據營運需要、司機狀態、積分、位置和車型等決定。司機接單前應核對內容，未經許可不得轉交他人。

7. 服務規範
司機應準時到達、安全駕駛、禮貌服務、保護行李和個人資料，並準確回報到達、上車、完成、等待、追加費用和異常情況。

8. 司機義務
司機必須遵守法律、交通規則、機場及設施規定和 Big Taxi 指示。疲勞、飲酒、藥物影響駕駛、資格無效或其他不安全狀態下不得駕駛，不得虛假回報。

9. 禁止事項
禁止違法或危險駕駛、使用未授權車輛、偽造資料或報告、騷擾或歧視、繞過平台私下交易、共享帳號、洩露或擅自複製平台資料、竄改或逆向分析 App、非法存取系統，以及其他損害客戶或平台的行為。

10. 報酬與結算
報酬、手續費、結算方式和付款時間以另行約定為準。App 顯示金額為暫定值；發生取消、遲到、未完成、投訴、事故、退款、追加費用或顯示錯誤時，Big Taxi 可以更正結算。未經許可不得向客戶收費。

11. 積分與評價
Big Taxi 可依完成率、接單、取消、遲到、評價、投訴、事故和配合情況調整積分。積分可用於派單、審核和帳號管理，除另有說明外不具有現金價值。

12. 事故與異常
發生事故、受傷、故障、糾紛、物品損壞、遺失或延誤時，應先確保安全，必要時聯絡警察、消防和保險公司，並立即向 Big Taxi 報告和配合處理。

13. 個人資料與保密
Big Taxi 依隱私政策處理司機資料。司機必須對客戶、訂單、價格、合作方及營運資料保密，僅可為完成服務而使用，保密義務在訂單和帳號結束後仍然有效。

14. 帳號安全
司機應妥善保管帳號、密碼、驗證資料和裝置，不得出借、轉讓或共享帳號。發現異常登入應立即報告。

15. 服務停止或變更
因維護、故障、外部服務中斷、災害、法律行政要求或營運需要，Big Taxi 可暫停、變更或終止全部或部分服務。

16. 使用限制與註銷
違反條款、資料虛假或嚴重缺失、違法、事故、投訴、安全問題、損害他人、長期不使用、拒絕合理聯絡或其他不適合繼續提供服務的情況，Big Taxi 可限制訂單、暫停帳號或取消資格。

17. 排除反社會勢力
司機及所屬單位確認與暴力團等反社會勢力無關，也不會提供利益、名義、業務或資金。

18. 智慧財產權
App、標誌、設計、文字、圖片、程式和資料庫歸 Big Taxi 或合法權利人所有，未經許可不得複製、修改、銷售、散佈或公開。

19. 責任
司機違反條款或因故意、過失造成損失時，可能承擔賠償責任。除故意或重大過失及法律另有規定外，Big Taxi 不承擔相關損失。

20. 條款變更
因法律、服務或營運需要，Big Taxi 可修改條款，並透過 App、網站、電子郵件或其他適當方式通知。生效後繼續使用即視為同意。

21. 法律與管轄
本條款適用日本法律，與本服務有關的爭議由 Big Taxi 所在地有管轄權的日本法院作為一審專屬管轄法院。

22. 協商
未規定事項或解釋疑義由雙方誠信協商解決。

附則
條款生效日期將在 App 中公布。`;

export function getDriverTerms(language) {
  const normalized = normalizeDriverLanguage(language);
  if (normalized === 'en') return { title: englishDriverTermsTitle, text: englishDriverTermsText };
  if (normalized === 'zh_cn') return { title: simplifiedDriverTermsTitle, text: simplifiedDriverTermsText };
  if (normalized === 'zh_tw') return { title: traditionalDriverTermsTitle, text: traditionalDriverTermsText };
  return { title: driverTermsTitle, text: driverTermsText };
}
